import apiClient from './client';

export interface ParentChildLink {
  parentId: string;
  childId: string;
}

export const parentChildApi = {
  linkParentChild: (data: ParentChildLink) => {
    return apiClient.post('/parent-child', data);
  },

  unlinkParentChild: (parentId: string, childId: string) => {
    return apiClient.delete(`/parent-child/${parentId}/${childId}`);
  },

  getParentChildren: (parentId: string) => {
    return apiClient.get(`/parent-child/parent/${parentId}/children`);
  },

  getChildParents: (childId: string) => {
    return apiClient.get(`/parent-child/child/${childId}/parents`);
  },

  searchUsers: (role: 'PARENT' | 'PLAYER', search: string) => {
    return apiClient.get('/parent-child/search', {
      params: { role, search },
    });
  },
};
